import { useQuery } from '@tanstack/react-query';
import { default as productsService } from "@/components/Contractation/services/products";
import { 
  IStepInstallationFormData, 
  IStepPersonFormData,
  StepElecContractFormData
} from '../../types/stepsFormData';


interface IUseProductsProps {
  power: StepElecContractFormData["power"]; 
  selfcons: StepElecContractFormData["selfcons"];
  accessTariff: StepElecContractFormData["accessTariff"];
  promotionalCode: StepElecContractFormData["promotionalCode"];
  cups: IStepInstallationFormData["cups"];
  lang: IStepPersonFormData["commsLanguage"];
}

export const useProducts = ({
  power,
  selfcons,
  accessTariff,
  cups,
  promotionalCode,
  lang
}: IUseProductsProps) => {
  const isReady = 
    power !== null 
    && !!accessTariff
    && cups !== '';

  return useQuery({
    queryKey: ['products', power, selfcons, accessTariff, cups, promotionalCode, lang],
    queryFn: () => productsService.fetchAvailableProducts({
      power,
      selfcons,
      accessTariff,
      cups,
      promotionalCode,
    }),
    enabled: isReady,
    staleTime: 1000 * 60 * 30 // 5 minutes (cached data remains fresh for this duration)
  })
}

export const useGasProducts = ({
  accessTariff,
  cups,
  lang
}: Pick<IUseProductsProps, "accessTariff" | "cups" | "lang">) => {
  const isReady = !!accessTariff && cups !== '';

  return useQuery({
    queryKey: ['gasProducts', accessTariff, cups, lang],
    queryFn: () => productsService.fetchAvailableGasProducts({
      accessTariff,
      cups,
    }),
    enabled: isReady,
    staleTime: 1000 * 60 * 30 // 5 minutes (cached data remains fresh for this duration)
  })
}